import React from 'react';
import { BusinessHubContainer } from './Search.style';
import BuisnessPlace from 'pages/business';

export default function BusinessHub({ keyword }) {
  return (
    <BusinessHubContainer>
      <BuisnessPlace keyword={keyword} />
    </BusinessHubContainer>
  );
}
